import { IconBellMediumOutline, IconCloseMediumOutline, IconWarningBadgedMediumOutline } from '@teamleader/ahoy';
import cx from 'classnames';
import React, { ReactNode } from 'react';

import * as styles from './styles.css';
import Box from '../Box';
import IconButton from '../IconButton';

export interface BannerProps {
  label: string | ReactNode;
  variant?: 'error' | 'info' | 'warning';
  dismissFunction?: () => void;
}

const Banner: React.FC<BannerProps> = ({ label, variant = 'info', dismissFunction }) => {
  const classNames = cx(styles['banner'], styles[`variant-${variant}`]);

  return (
    <Box className={classNames}>
      {variant === 'info' ? (
        <IconBellMediumOutline className={styles['banner-icon']} />
      ) : (
        <IconWarningBadgedMediumOutline className={styles['banner-icon']} />
      )}
      <p>{label}</p>
      {dismissFunction && (
        <IconButton
          icon={<IconCloseMediumOutline />}
          className={styles['banner-icon-close']}
          onClick={dismissFunction}
        />
      )}
    </Box>
  );
};

export default Banner;
